export const apiDomain = "https://ospv2.kndi.institute/"
//export const apiDomain = "http://localhost:8000/"
export const upgrading_exam_stepper_resit_check_Url =
  apiDomain + "api/examination/upgrading/stepper/one/resit"
export const upgrading_exam_stepper_one_check_one_Url =
  apiDomain + "api/examination/upgrading/stepper/one/check/one"
export const upgrading_exam_stepper_one_check_two_Url =
  apiDomain + "api/examination/upgrading/stepper/one/check/two"
export const upgrading_exam_stepper_one_dataUrl =
  apiDomain + "api/examination/upgrading/stepper/one/data"
export const upgrading_exam_file_uploadUrl =
  apiDomain + "api/examination/upgrading/stepper/one/file/upload"
export const upgradeExamRegisterUrl =
  apiDomain + "api/examination/upgrading/stepper/one/store"
export const upgradeExamResitRegisterUrl =
  apiDomain + "api/examination/upgrading/stepper/one/resit/store"
export const upgradingExamApplicationCorrectUrl =
  apiDomain + "api/examination/upgrading/correct"
export const upgradingExamStepperDataTokenUrl =
  apiDomain + "api/examination/upgrading/correct/token"
export const examSlotIndexUrl =
  apiDomain + "api/examination/upgrading/set_slot_index"
export const examSlotCreateUrl =
  apiDomain + "api/examination/upgrading/set_slot_create"
export const examPaperOpenUrl =
  apiDomain + "api/examination/upgrading/paper/confirm_open"
export const examPaperTokenUrl =
  apiDomain + "api/examination/upgrading/paper/confirm_token"
export const examPaperAnswerUrl =
  apiDomain + "api/examination/upgrading/paper/confirm_answer"
export const examPaperOnline_OpenUrl =
  apiDomain + "api/examination/upgrading/online-paper/confirm_open"
export const examPaperOnline_TokenUrl =
  apiDomain + "api/examination/upgrading/online-paper/confirm_token"
export const examPaperOnline_AnswerUrl =
  apiDomain + "api/examination/upgrading/online-paper/confirm_answer"
export const getHeader = function() {
  const tokenData = window.$cookies.get("authUser")
  const headers = {
    Accept: "application/json",
    Authorization: "Bearer " + tokenData.access_token
  }
  return headers
}

export const getHeaderVisitor = function() {
  const headers = {
    Accept: "application/json"
  }
  return headers
}



// WEBPACK FOOTER //
// ./src/config.js